import { useMemo } from 'react';

import { FieldBehaviorMode } from '@app/queryTyping';

import { FieldInfoGroupField } from '@app/common/configurable-wizards';
import { isTruthy } from '@app/common/utils';

import { getMappedFields } from '@app/widgets/contacts-and-settings/utils/subFieldsMapper';

export const useContactFieldMeta = (field: FieldInfoGroupField) => {
  const fieldMeta = useMemo(() => getMappedFields(field.subFields), [field]);
  const currentField = fieldMeta?.MobilePhone || fieldMeta?.PrimaryEmail;

  const isReadonly = FieldBehaviorMode.READONLY === currentField?.fieldBehaviorMode;
  const isPrimary = isTruthy(fieldMeta?.IsPrimary?.sValue);

  return {
    fieldMeta,
    isReadonly,
    isPrimary,
  };
};
